// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ServiceLineResponse } from './service-line-response';

/** See com.rev360.pms.api.controller.accounting.payment.PaymentInfoResponse */
/* istanbul ignore next */
@GandalfModel
export class PaymentInfoResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	claimId!: string;

	@GandalfProperty({ designType: String })
	claimStatus!: string | null;

	@GandalfProperty({ designType: String })
	insuredFirstName!: string | null;

	@GandalfProperty({ designType: String })
	insuredIdentificationNumber!: string | null;

	@GandalfProperty({ designType: String })
	insuredLastName!: string | null;

	@GandalfProperty({ designType: String })
	insuredMiddleName!: string | null;

	@GandalfProperty({ designType: String })
	insuredSuffix!: string | null;

	@GandalfProperty({ designType: String })
	memberIdentificationNumber!: string | null;

	@GandalfProperty({ designType: String })
	patientFirstName!: string | null;

	@GandalfProperty({ designType: String })
	patientLastName!: string | null;

	@GandalfProperty({ designType: String })
	patientMiddleName!: string | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	patientResponsibility!: number;

	@GandalfProperty({ designType: String })
	patientSuffix!: string | null;

	@GandalfProperty({ designType: String })
	payerClaimControlNumber!: string | null;

	@GandalfProperty({ designType: String })
	renderingProviderFirstName!: string | null;

	@GandalfProperty({ designType: String })
	renderingProviderLastName!: string | null;

	@GandalfProperty({ designType: String })
	renderingProviderNPI!: string | null;

	@GandalfArray(ServiceLineResponse)
	serviceLines!: ServiceLineResponse[] | null;

}
